var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "design-list-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("\n            Дизайн\n        ")
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "new-design-frame" } }, [
        _c(
          "div",
          {
            staticClass: "red-pill-button-of-hate",
            on: { click: _vm.createNewDesign }
          },
          [_vm._v("Создать дизайн")]
        )
      ]),
      _vm._v(" "),
      _c("DesignList", {
        ref: "designList",
        attrs: { isLite: false },
        on: { selectDesign: _vm.selectDesign, openDesign: _vm.openDesign }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }